import React from 'react';
import styled from 'styled-components';

interface ItemProps {
  isActive: boolean;
  children: React.ReactNode;
}

export default function Item({ children, isActive }: ItemProps) {
  return <ListItem className={isActive ? 'active' : ''}>{children}</ListItem>;
}

const ListItem = styled.li`
  display: flex;
  width: 32px;
  height: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid #dbe0ef;
  & a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: #262626;
    font-family: var(--font-roboto);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  &.active {
    border-radius: 4px;
    background: #4688f1;
    & a {
      color: white;
    }
  }
`;
